import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import HomePage3 from '../HomePage3/HomePage3';
import HomePage4 from '../HomePage4/HomePage4';
import AboutPage from '../AboutPage/AboutPage';
import CausePageOn from '../CausePageOn/CausePageOn';
import CausePagetwo from '../CausePagetwo/CausePagetwo';
import DonatePage from '../DonatePage/DonatePage';
import ServicePage from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import TeamPage from '../TeamPage/TeamPage';
import TestimonialPage from '../TestimonialPage/TestimonialPage';
import LoginPage from '../LoginPage/index';
import ForgotPassword from '../ForgotPassword/index';
import Register from '../SignUpPage/index';
import EventPage from '../EventPage/EventPage';
import EventPagetwo from '../EventPagetwo/EventPagetwo';
import EventSinglePage from '../EventSinglePage/EventSinglePage';
import BlogPage from '../BlogPage/BlogPage'
import BlogPageLeft from '../BlogPageLeft/BlogPageLeft'
import BlogPageFullwidth from '../BlogPageFullwidth/BlogPageFullwidth'
import BlogDetails from '../BlogDetails/BlogDetails'
import BlogDetailsFull from '../BlogDetailsFull/BlogDetailsFull'
import BlogDetailsLeftSiide from '../BlogDetailsLeftSiide/BlogDetailsLeftSiide'
import ContactPage from '../ContactPage/ContactPage';
import ErrorPage from '../ErrorPage/ErrorPage';
import ChatbotPage from '../ChatbotPage/index';
import GalleryPage from '../GalleryPage/GalleryPage';
import PatternGeneratorBot from '../ChatbotGenerateImage/index';
import VRPage from '../VRPage';
import HuongDanPageNew from '../HuongDanPage/HuongDanPageNew';
import SanPhamPage from '../SanPhamPage/SanPhamPage';
import SanPhamDetailPage from '../SanPhamPage/SanPhamDetailPage';
import TracNghiemPage from '../TracNghiemPage';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          <Route path="home-3" element={<HomePage3 />} />
          <Route path="home-4" element={<HomePage4 />} />
          <Route path="about" element={<AboutPage />} />
          <Route path='image-ai' element={<ChatbotPage />}/>
          <Route path='image-generate' element={<PatternGeneratorBot/>}/>
          <Route path='gallery' element={<GalleryPage />}/>
          <Route path='vr' element={<VRPage />}/>
          <Route path="cause" element={<CausePageOn />} />
          <Route path="cause-2" element={<CausePagetwo />} />
          <Route path="donate" element={<DonatePage />} />
          <Route path="service" element={<ServicePage />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="testimonial" element={<TestimonialPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="forgot" element={<ForgotPassword />} />
          <Route path="register" element={<Register />} />
          <Route path="events" element={<EventPage />} />
          <Route path="events-2" element={<EventPagetwo />} />
          <Route path="events-single/:slug" element={<EventSinglePage />} />
          <Route path='blog' element={<BlogPage />} />
          <Route path='blog-left-sidebar' element={<BlogPageLeft />} />
          <Route path='blog-fullwidth' element={<BlogPageFullwidth />} />
          <Route path='blog-single/:slug' element={<BlogDetails />} />
          <Route path='blog-single-fullwidth/:slug' element={<BlogDetailsFull />} />
          <Route path='blog-single-left-sidebar/:slug' element={<BlogDetailsLeftSiide />} />
          <Route path='contact' element={<ContactPage />} />
          <Route path='404' element={<ErrorPage />} />
          <Route path='huongdan' element={<HuongDanPageNew />} />
          <Route path='sanpham' element={<SanPhamPage />} />
          <Route path='sanpham/:id' element={<SanPhamDetailPage />} />
          <Route path='/tracnghiem' element={<TracNghiemPage />} />
  
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
